export default [
  {
    path: '/app/defines/departments',
    name: 'Departments',
    component: () => import('@/views/Defines/Departments/Index.vue'),
    meta: {
      pageTitle: 'nav.departments',
      breadcrumb: [
        {
          text: 'breadcrumb.list',
          active: true,
        },
      ],
      resource: 'DEPARTMENTS_LIST',
      action: 'read',
    },
  },
  {
    path: '/app/defines/departments/add',
    name: 'DepartmentsAdd',
    component: () => import('@/views/Defines/Departments/Add.vue'),
    meta: {
      pageTitle: 'nav.departments',
      breadcrumb: [
        {
          text: 'breadcrumb.list',
          to: '/app/defines/departments',
          active: false,
        },
        {
          text: 'breadcrumb.create',
          active: true,
        },
      ],
      resource: 'DEPARTMENTS_ADD',
      action: 'read',
    },
  },
  {
    path: '/app/defines/departments/edit/:id',
    name: 'DepartmentsEdit',
    component: () => import('@/views/Defines/Departments/Edit.vue'),
    meta: {
      pageTitle: 'nav.departments',
      breadcrumb: [
        {
          text: 'breadcrumb.list',
          to: '/app/defines/departments',
          active: false,
        },
        {
          text: 'breadcrumb.update',
          active: true,
        },
      ],
      resource: 'DEPARTMENTS_EDIT',
      action: 'read',
    },
  },
]
